import { Component, OnInit, HostListener, HostBinding } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CargoheatingCommonService } from 'src/app/shared/service/cargo-heating-service/cargoheating-common.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-total-ship-table',
  templateUrl: './total-ship-table.component.html',
  styleUrls: ['./total-ship-table.component.scss']
})
export class TotalShipTableComponent implements OnInit {
  totalShipData: any[] = [];
  paginatedData: any[] = [];
  /** Drives the skeleton loader while table data is loading. */
  isLoading = true;
  itemsPerPage = 25;
  currentPage = 0;
  cargoTypeOptions: any;
  filterForm!: FormGroup;
fromVoyageMetrics: boolean = false;
  cargoOperation = ['Loading', 'Discharging', 'Idle'];
  elements: any[] | undefined;

  // Modern Filter State
  cargoSearchQuery: string = '';
  cargoDropdownOpen = false;
  portNameSuggestions: any[] = [];

  constructor(
    private commonService: CargoheatingCommonService,
    private router: Router,
    private fb: FormBuilder,
    private requestFormService: RequestFormService,
  ) { }

  ngOnInit(): void {
    // Init filter form
    this.filterForm = this.fb.group({
      from_date: [null],
      to_date: [null],
      cargoOperation: [null],
      portName: [''],
      shipName: [''],
      imoNumber: [''],
      cargoType: ['']
    });


    const state = window.history.state;
this.fromVoyageMetrics = state?.fromVoyageMetrics || false; 
    const payload: any = {
      segments: (state.segments || []).map((s: string) => s.toLowerCase()),
      heat_flags: (state.heat_flags || []).map((h: string) => h === 'Yes' ? 'Y' : 'N'),
      grad_range_min: state.grad_range_min ? +state.grad_range_min : null,
      grad_range_max: state.grad_range_max ? +state.grad_range_max : null,
      cargo_types: state.cargo_types || []   //  Add this line
    };


    if (state.tanks && Array.isArray(state.tanks) && state.tanks.length > 0) {
      payload.tanks = state.tanks.map((t: string) => t.toLowerCase());
    }


  

    this.fetchShipData(payload);
  }

  /** Applies a Light Mode host class so scoped light-theme styles can activate. */
  @HostBinding('class.ch-light') get chLight(): boolean {
    return !this.isDarkMode();
  }

  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }

  // fetchShipData(payload: any) {
  //   console.log('Calling API with payload:', payload);

  //   this.commonService.fetchPivotDetailData(payload).subscribe({
  //     next: (res: any) => {
  //       console.log('API response:', res);

  //       if (res.success && res.ship_data) {
  //         const parsed = JSON.parse(res.ship_data); 
  //         const data = parsed.data;

  //         this.totalShipData = data.map((row: any[]) => ({
  //           shipName: row[0],
  //           imo: row[1],
  //           cargoType: row[2],
  //           voyageStartDate: row[3],
  //           avgTempDrop: row[4],
  //           minTempDrop: row[5],
  //           maxTempDrop: row[6]
  //         }));

  //         this.currentPage = 0;
  //         this.paginateData();
  //       }
  //     },
  //     error: (err: any) => {
  //       console.error('API ERROR:', err);
  //     }
  //   });
  // }
  // fetchShipData(payload: any) {
  //   console.log('Calling API with payload:', payload);

  //   this.commonService.fetchPivotDetailData(payload).subscribe({
  //     next: (res: any) => {
  //       console.log('API response:', res);

  //       if (res.success && res.ship_data) {
  //         const parsed = JSON.parse(res.ship_data);
  //         const data = parsed.data;

  //         this.totalShipData = data.map((row: any[]) => ({
  //           shipName: row[0],
  //           imo: row[1],
  //           cargoType: row[2],
  //           voyageStartDate: row[3],
  //           avgTempDrop: row[4],
  //           minTempDrop: row[5],
  //           maxTempDrop: row[6]
  //         }));

  //         // Extract unique cargo types
  //         const uniqueCargoTypes = [...new Set(data.map((row: any[]) => row[2]))] as string[];
  //         this.cargoTypeOptions = [...new Set(data.map((row: any[]) => row[2]))] as string[];



  //         this.currentPage = 0;
  //         this.paginateData();
  //       }
  //     },
  //     error: (err: any) => {
  //       console.error('API ERROR:', err);
  //     }
  //   });
  // }
fetchShipData(payload: any) {
  console.log('Calling API with payload:', payload);

  const apiCall = this.fromVoyageMetrics
    ? this.commonService.fetchPivotDetailDatam(payload)   //  predicted_voyage
    : this.commonService.fetchPivotDetailData(payload);   //  normal API

  this.isLoading = true;
  apiCall.subscribe({
    next: (res: any) => {
      console.log('API response:', res);

      if (res.success && res.ship_data) {
        const parsed = JSON.parse(res.ship_data);
        const data = parsed.data;

        this.totalShipData = data.map((row: any[]) => ({
          shipName: row[0],
          imo: row[1],
          cargoType: row[2],
          voyageStartDate: row[3],
          avgTempDrop: row[4],
          minTempDrop: row[5],
          maxTempDrop: row[6]
        }));

        this.cargoTypeOptions = [
          ...new Set(data.map((row: any[]) => row[2]))
        ] as string[];

        this.currentPage = 0;
        this.paginateData();
      }
      this.isLoading = false;
    },
    error: (err: any) => {
      console.error('API ERROR:', err);
      this.isLoading = false;
    }
  });
}
  onPageChange(event: any) {
    this.currentPage = event.pageIndex;
    this.itemsPerPage = event.pageSize;
    this.paginateData();
  }

  paginateData() {
    const startIndex = this.currentPage * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.paginatedData = this.totalShipData.slice(startIndex, endIndex);
  }

  // For filtering port name suggestions
  filterPortNames(event: Event): void {
    const input = (event.target as HTMLInputElement).value.toLowerCase();
    this.portNameSuggestions = this.getAllPorts().filter(port =>
      port.portName.toLowerCase().includes(input)
    );
  }

  getAllPorts() {
    return [
      { portName: 'Mumbai' },
      { portName: 'Chennai' },
      { portName: 'Kolkata' },
      { portName: 'Cochin' }
      // Add more ports as needed
    ];
  }

  clearClick(): void {
    this.filterForm.reset();
    this.cargoSearchQuery = '';
    this.cargoDropdownOpen = false;
    this.paginateData();
  }

  // Modern Dropdown Toggles
  toggleCargoDropdown(event?: Event) {
    if (event) event.stopPropagation();
    this.cargoDropdownOpen = !this.cargoDropdownOpen;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    this.cargoDropdownOpen = false;
  }

  getFilteredCargos() {
    return (this.cargoTypeOptions || []).filter((opt: string) => opt.toLowerCase().includes(this.cargoSearchQuery.toLowerCase()));
  }

  onCargoSelect(cargo: string) {
    this.filterForm.get('cargoType')?.setValue(cargo);
    this.cargoDropdownOpen = false;
    this.filterClick();
  }


  filterClick(): void {
    const { shipName, imoNumber, cargoType } = this.filterForm.value;

    this.paginatedData = this.totalShipData.filter(item => {
      const matchShip = shipName ? item.shipName?.toLowerCase().includes(shipName.toLowerCase()) : true;
      const matchIMO = imoNumber ? item.imo?.toLowerCase().includes(imoNumber.toLowerCase()) : true;
      const matchCargo = cargoType ? item.cargoType === cargoType : true;

      return matchShip && matchIMO && matchCargo;
    });

    console.log('Filtered Data:', this.paginatedData);
  }
  downloadClick() {
    const parseDate = (dateString: any) => {
      const date = new Date(dateString);
      if (!isNaN(date.getTime())) {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }
      return '';
    };

    const data = this.paginatedData || this.totalShipData;

    const csvHeader = 'S.No,Ship Name,IMO,Cargo Type,Voyage Start Date,Avg Temp Drop,Min Temp Drop,Max Temp Drop';

    const csvData = data.map((element: any, index: number) => {
      const voyageDate = element.voyageStartDate ? parseDate(element.voyageStartDate) : '';
      return [
        index + 1,
        element.shipName || '',
        element.imo || '',
        element.cargoType || '',
        voyageDate,
        element.avgTempDrop ?? '',
        element.minTempDrop ?? '',
        element.maxTempDrop ?? ''
      ].join(',');
    }).join('\n');

    const csvContent = `${csvHeader}\n${csvData}`;

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'total_ship_data.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  goBack() {
    this.router.navigate(['/ch-pivottable']);
  }
}
